import {Data, Events, Message, SuccessState} from './Messages';
import {RequestIdHelper} from './RequestIdHelper';

export class TerminalConfigurationRequest
{
    ToMessage()
    {
        const data = {};

        return new Message(RequestIdHelper.Id("trmnl"), Events.TerminalConfigurationRequest, data, true);
    }
}

export interface TerminalConfigurationResponseData extends Data {
  comms_selected: string
  merchant_id:string
  pa_version:string
  payment_interface_version:string
  plugin_version:string
  serial_number:string
  terminal_id:string
  terminal_model:string
}

export class TerminalConfigurationResponse
{
	public _success: boolean;
	public _m: Message<TerminalConfigurationResponseData>;

    constructor(m: Message<TerminalConfigurationResponseData>)
    {
        this._success = m.GetSuccessState() === SuccessState.Success;
        this._m = m;
    }

    isSuccess()
    {
      return this._success;
    }

    GetCommsSelected()
    {
      return this._m.Data.comms_selected;
    }

    GetMerchantId()
    {
      return this._m.Data.merchant_id;
    }

    GetPAVersion()
    {
      return this._m.Data.pa_version;
    }

    GetPaymentInterfaceVersion()
    {
      return this._m.Data.payment_interface_version;
    }

    GetPluginVersion()
    {
      return this._m.Data.plugin_version;
    }

    GetSerialNumber()
    {
      return this._m.Data.serial_number;
    }

    GetTerminalId()
    {
      return this._m.Data.terminal_id;
    }

    GetTerminalModel()
    {
      return this._m.Data.terminal_model;
    }
}
